import { api, apiV2 } from '../http';

export const getProcurementIntegrationDossier = procurementId =>
  apiV2.get(`/admin/integrations/procurements/${procurementId}`);

export const reprocessIntegration = payload => apiV2.post('/admin/integrations/reprocess', payload);

export const reprocessIntegrationBatch = payload =>
  apiV2.post('/admin/integrations/reprocess-batch', payload);

export const getAuctionTerms = ofertaCompraId =>
  api.get(`/admin/ofertas-compra/${ofertaCompraId}/termos`);

export const regenerateAuctionTerm = (ofertaCompraId, tipo) =>
  api.post(`/admin/ofertas-compra/${ofertaCompraId}/termos/${tipo}/regerar`);
